// extracted by mini-css-extract-plugin
export default {"main":"many_main__Q2IUW","active":"many_active__V2ew+","team":"many_team__lRBav"};